<template>
  <div id="app">
    <Hero />
    <Calculator />
    <Result />
    <Average />
    <Offer />
    <Savings />
    <Footer />
  </div>
</template>

<script>
import Hero from './components/Hero.vue'
import Calculator from "./components/Calculator";
import Result from "./components/Result";
import Average from "./components/Average";
import Offer from "./components/Offer";
import Savings from "./components/Savings";
import Footer from "./components/Footer";

export default {
  name: 'app',
  components: {
    Hero,
    Calculator,
    Result,
    Average,
    Offer,
    Savings,
    Footer
  }
}
</script>

<style>
#app {
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
